import './App.css';
import React, { useCallback, useEffect, useState } from 'react';
import Title from './wally-logo.png';
import Footer from './Footer.jsx';
import PhotoGrid from './PhotoGrid.jsx';
import Lightbox from './Lightbox.jsx';
import poster2026 from './wally_mclean_poster_2026.jpg';
import champ2022 from './2022-wally-champ.png';
import champ2023 from './2023-wally-champ.png';
import champ2021 from './2021-wally-champ.png';
import bracketicon from './bracketicon.png';
import gallery1 from './wally_mclean_2.jpg';
import gallery2 from './wally_mclean_1.jpg';
import gallery3 from './wally_mclean_memorial_donation.jpg';
import gallery4 from './wally_mclean_memorial_team.jpg';

const streamCover = gallery1;

const STREAM_URL =
  'https://www.youtube.com/@rodarriagadacslmanitoba8434/search?query=wally';

const memorialPhotos = [
  {
    src: 'https://i.postimg.cc/T3V62MZT/wally1.jpg',
    alt: 'Wally McLean relaxing at home with a baby and the family dog',
  },
  {
    src: 'https://i.postimg.cc/52VtS3JN/wally12.jpg',
    alt: 'Wally McLean and a friend joking around by the Christmas tree',
  },
  {
    src: 'https://i.postimg.cc/rwNwnryG/wally13.jpg',
    alt: 'Wally McLean at a mountain lookout in the Rockies',
  },
  {
    src: 'https://i.postimg.cc/1XF9pgYq/wally19.jpg',
    alt: 'Wally McLean at the mall, from the photo used on the memorial poster',
  },
  {
    src: 'https://i.postimg.cc/zvbs99CZ/wally2.jpg',
    alt: 'Lining up an 8-ball shot on a blue-felt pool table',
  },
  {
    src: 'https://i.postimg.cc/W1T2k1md/wally32.jpg',
    alt: 'Wally McLean out on the golf course in a golf cart',
  },
  {
    src: 'https://i.postimg.cc/qRPrMJMM/wally37.jpg',
    alt: 'Wally McLean and a young boy pulling faces together in the truck',
  },
  {
    src: 'https://i.postimg.cc/524Vtk1v/wally41.jpg',
    alt: 'Wally McLean with three friends at a house gathering',
  },
  {
    src: 'https://i.postimg.cc/7Lbr3G5Z/wally42.jpg',
    alt: 'Wally McLean driving with a laughing toddler in the back seat',
  },
  {
    src: 'https://i.postimg.cc/nVqbGthB/wally47.jpg',
    alt: 'Wally McLean holding up a freshly caught fish by the lake',
  },
  {
    src: 'https://i.postimg.cc/YStwhDHY/wally7.jpg',
    alt: 'Wally McLean with friends on a night out',
  },
  {
    src: 'https://i.postimg.cc/v8PnHCWF/wally10.jpg',
    alt: 'A framed baby photo of Wally McLean',
  },
  {
    src: 'https://i.postimg.cc/7YdTS7sK/wally11.jpg',
    alt: 'Wally McLean wearing a straw cowboy hat at home',
  },
  {
    src: 'https://i.postimg.cc/XvcGMPVP/wally17.jpg',
    alt: 'Wally McLean and a friend leaning in for a selfie',
  },
  {
    src: 'https://i.postimg.cc/xCfk9P81/wally18.jpg',
    alt: 'Wally McLean and two kids goofing around in the car',
  },
  {
    src: 'https://i.postimg.cc/sx1vhDpF/wally20.jpg',
    alt: 'Wally McLean out for a drink with a friend',
  },
  {
    src: 'https://i.postimg.cc/26GZWKMW/wally3.jpg',
    alt: 'Five friends of Wally McLean gathered outside on a summer evening',
  },
  {
    src: 'https://i.postimg.cc/wTy1xMqL/wally31.jpg',
    alt: 'Wally McLean laughing with friends around a restaurant table',
  },
  {
    src: 'https://i.postimg.cc/tJf7tQ5s/wally33.jpg',
    alt: 'Wally McLean at home with two family elders',
  },
  {
    src: 'https://i.postimg.cc/kMhVdKm7/wally34.jpg',
    alt: 'Wally McLean riding a fairground swing with a little girl',
  },
  {
    src: 'https://i.postimg.cc/CL3zR05t/wally35.jpg',
    alt: 'Wally McLean and a family member out at the bar',
  },
  {
    src: 'https://i.postimg.cc/7ZSb7RTL/wally36.jpg',
    alt: 'Kids in Halloween costumes trick-or-treating from the back of an SUV in the snow',
  },
  {
    src: 'https://i.postimg.cc/bv8rRRQ9/wally38.jpg',
    alt: 'Wally McLean hugging friends at a house party',
  },
  {
    src: 'https://i.postimg.cc/sx0G6ZVD/wally4.jpg',
    alt: 'Wally McLean in the stands at a hockey game',
  },
  {
    src: 'https://i.postimg.cc/pdZTcnCb/wally40.jpg',
    alt: 'Wally McLean and a child pulling wide-eyed faces in the car',
  },
  {
    src: 'https://i.postimg.cc/8cFzCXSN/wally43.jpg',
    alt: 'Wally McLean out for a meal at a restaurant',
  },
  {
    src: 'https://i.postimg.cc/MT3Gq2g9/wally46.jpg',
    alt: 'Wally McLean sitting on a park bench with a young boy',
  },
  {
    src: 'https://i.postimg.cc/50bz6V71/wally5.jpg',
    alt: 'Wally McLean in a hard hat and safety vest on a work site',
  },
  {
    src: 'https://i.postimg.cc/5ytFSmWR/wally8.jpg',
    alt: 'Wally McLean driving through the mountains with a coffee',
  },
];

const navLinks = [
  { id: 'home', label: 'Home' },
  { id: 'bracket', label: 'Bracket' },
  { id: 'stream', label: 'Stream' },
  { id: 'gallery', label: 'Gallery' },
  { id: 'history', label: 'Results' },
];

const galleryImages = [
  { src: gallery1, alt: 'Wally McLean Memorial supporters at a summer gathering' },
  { src: gallery2, alt: 'Three players after a day of mud bogging' },
  {
    src: gallery3,
    alt: 'Cheque presentation of $6,745 to the Canadian Mental Health Association Manitoba and Winnipeg in memory of Wally McLean',
  },
  { src: gallery4, alt: 'Team The Show wearing In Memory shirts at the tournament' },
  ...memorialPhotos,
];

const champions = [
  {
    year: '2025',
    team: "Henry's Team",
    image: champ2023,
    imagePending: true,
    bracket: 'https://challonge.com/ny7jc451',
  },
  {
    year: '2024',
    team: 'Anybody',
    image: champ2023,
    imagePending: true,
    bracket: 'https://challonge.com/t9n5k1e4',
  },
  {
    year: '2023',
    team: 'House of Pain',
    image: champ2023,
    bracket: 'https://challonge.com/wally_mclean_memorial_2023',
  },
  {
    year: '2022',
    team: 'Snake Bit Pool Dawgs',
    image: champ2022,
    bracket: 'https://challonge.com/ca3w5xya',
  },
  {
    year: '2021',
    team: 'Blue Room Bandits',
    image: champ2021,
    bracket: 'https://challonge.com/i26x39bi',
  },
];

function CalendarIcon() {
  return (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
      <rect x="3" y="5" width="18" height="16" rx="2" />
      <path d="M8 3v4M16 3v4M3 11h18" />
    </svg>
  );
}

function PinIcon() {
  return (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
      <path d="M20 10c0 6-8 12-8 12S4 16 4 10a8 8 0 1 1 16 0Z" />
      <circle cx="12" cy="10" r="3" />
    </svg>
  );
}

function PlayIcon() {
  return (
    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" aria-hidden="true">
      <rect x="2" y="4" width="20" height="16" rx="4" />
      <path d="M10 9l5 3-5 3V9Z" fill="currentColor" />
    </svg>
  );
}

function ExternalIcon() {
  return (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M8 16 16 8M9 8h7v7" />
    </svg>
  );
}

/* Frosted placeholder shown over artwork that isn't ready yet. */
function ComingSoon({ label }) {
  return (
    <div className="coming-soon">
      <span className="coming-soon__badge">{label}</span>
    </div>
  );
}

/* Reveals a section's contents once it scrolls into view. Threshold is 0 so
   that a single pixel is enough: a ratio-based threshold never fires for an
   element taller than the viewport (the photo gallery on a phone), which left
   it stuck at opacity 0. The rootMargin still keeps it from firing until the
   element is comfortably past the bottom edge. */
function useReveal() {
  useEffect(() => {
    const targets = document.querySelectorAll('.reveal');
    if (!('IntersectionObserver' in window)) {
      targets.forEach((el) => el.classList.add('is-visible'));
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0 }
    );

    targets.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);
}

/* Highlights the nav link for whichever section is on screen. */
function useActiveSection() {
  const [active, setActive] = useState('home');

  useEffect(() => {
    const sections = navLinks
      .map((link) => document.getElementById(link.id))
      .filter(Boolean);
    if (!sections.length || !('IntersectionObserver' in window)) return undefined;

    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries
          .filter((entry) => entry.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
        if (visible) setActive(visible.target.id);
      },
      { rootMargin: '-30% 0px -55% 0px', threshold: [0, 0.2, 0.5] }
    );

    sections.forEach((section) => observer.observe(section));
    return () => observer.disconnect();
  }, []);

  return active;
}

function App() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [lightboxImage, setLightboxImage] = useState(null);
  const [stuck, setStuck] = useState(false);
  const active = useActiveSection();

  useReveal();

  useEffect(() => {
    const onScroll = () => setStuck(window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const closeMenu = useCallback(() => setMenuOpen(false), []);

  return (
    <div className="App">
      <header className={`site-header${stuck ? ' is-stuck' : ''}`}>
        <div className="shell site-header__inner">
          <a className="site-header__logo" href="#home" onClick={closeMenu}>
            <img src={Title} alt="Wally McLean Memorial" />
          </a>

          <nav className={`site-nav${menuOpen ? ' is-open' : ''}`} aria-label="Main">
            <ul>
              {navLinks.map((link) => (
                <li key={link.id}>
                  <a
                    href={`#${link.id}`}
                    className={active === link.id ? 'is-active' : undefined}
                    aria-current={active === link.id ? 'true' : undefined}
                    onClick={closeMenu}
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <button
            type="button"
            className="nav-toggle"
            aria-expanded={menuOpen}
            aria-label="Toggle menu"
            onClick={() => setMenuOpen((open) => !open)}
          >
            <span />
            <span />
            <span />
          </button>
        </div>
      </header>

      <main>
        <section
          id="home"
          className="hero"
          style={{ '--hero-image': `url(${memorialPhotos[5].src})` }}
        >
          <div className="hero__bg" aria-hidden="true" />
          <div className="hero__veil" aria-hidden="true" />

          <div className="shell hero__grid">
            <div className="reveal">
              <span className="eyebrow">6th Annual</span>
              <h1 className="hero__title">
                <span>Wally</span>
                <span className="accent">McLean</span>
                <span className="sub">Memorial 8-Ball Tournament</span>
              </h1>
              <div className="hero__rule" />

              <div className="hero__meta">
                <span className="chip">
                  <CalendarIcon />
                  Nov 13&ndash;15, 2026
                </span>
                <span className="chip">
                  <PinIcon />
                  Sonix Bar &amp; Grill
                </span>
              </div>
            </div>

            <div className="hero__poster reveal">
              <div className="media-lock">
                <img
                  src={poster2026}
                  alt="6th Annual Wally McLean Memorial 8-Ball Tournament poster: November 13-15, 2026 at Sonix Bar & Grill, $5000 added"
                />
              </div>
            </div>
          </div>
        </section>

        <section id="bracket" className="section section--alt">
          <div className="shell shell--wide">
            <div className="section__head reveal">
              <span className="section__label">Bracket</span>
              <h2 className="section__title">2026 Wally McLean Memorial Bracket</h2>
            </div>

            <div className="bracket-actions reveal">
              <span className="bracket-link is-disabled">
                <img src={bracketicon} alt="" />
                <span>2026 Full Bracket (TBD)</span>
              </span>
            </div>

            <div className="bracket-frame reveal">
              <div className="bracket-frame__bar">challonge.com</div>
              <div className="media-lock">
                <iframe
                  className="is-blurred"
                  title="2026 Wally McLean Memorial bracket"
                  src="https://challonge.com/t9n5k1e4/module?theme=8228&amp;multiplier=1&amp;match_width_multiplier=1&amp;show_final_results=1&amp;show_standings=0&amp;show_live_status=0&amp;subdomain="
                  allow="fullscreen"
                  frameBorder="0"
                  scrolling="no"
                  tabIndex={-1}
                />
                <ComingSoon label="2026 Bracket Coming Soon" />
              </div>
            </div>
          </div>
        </section>

        <section id="stream" className="section">
          <div className="shell">
            <div className="section__head reveal">
              <span className="section__label">Watch</span>
              <h2 className="section__title">Tournament Stream</h2>
            </div>

            <a
              className="stream-card reveal"
              href={STREAM_URL}
              target="_blank"
              rel="noreferrer"
            >
              <img
                className="stream-card__media"
                src={streamCover}
                alt=""
                loading="lazy"
              />
              <span className="stream-card__body">
                <span className="stream-card__play">
                  <PlayIcon />
                </span>
                <span className="stream-card__text">
                  <span className="stream-card__title">
                    Wally McLean Memorial Stream
                  </span>
                  <span className="stream-card__sub">
                    Tournament videos on YouTube
                  </span>
                </span>
                <span className="btn btn--primary stream-card__cta">
                  Watch on YouTube
                  <ExternalIcon />
                </span>
              </span>
            </a>
          </div>
        </section>

        <section id="gallery" className="section section--alt">
          <div className="shell">
            <div className="section__head reveal">
              <span className="section__label">Photos</span>
              <h2 className="section__title">Tournament Gallery</h2>
            </div>

            <div className="reveal">
              <PhotoGrid
                images={galleryImages}
                orientation="poster"
                onSelect={setLightboxImage}
                mobileCarousel
              />
            </div>
          </div>
        </section>

        <section id="history" className="section">
          <div className="shell">
            <div className="section__head reveal">
              <span className="section__label">Tournament Results</span>
              <h2 className="section__title">Champions History</h2>
            </div>

            <div className="champ-grid">
              {champions.map((champ) => (
                <article className="champ-card reveal" key={champ.year}>
                  <div className="champ-card__media">
                    <img
                      className={champ.imagePending ? 'is-blurred' : undefined}
                      src={champ.image}
                      alt={
                        champ.imagePending
                          ? ''
                          : `Wally McLean Memorial ${champ.year} champions`
                      }
                      loading="lazy"
                    />
                    {champ.imagePending && <ComingSoon label="Image Coming Soon" />}
                    <span className="champ-card__year">{champ.year}</span>
                  </div>
                  <div className="champ-card__body">
                    <span className="champ-card__label">Champions</span>
                    <h3 className="champ-card__team">{champ.team}</h3>
                    {champ.bracket ? (
                      <a
                        className="champ-card__link"
                        href={champ.bracket}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <img src={bracketicon} alt="" />
                        {champ.year} Full Bracket
                      </a>
                    ) : (
                      <span className="champ-card__link is-disabled">
                        <img src={bracketicon} alt="" />
                        {champ.year} Full Bracket (TBD)
                      </span>
                    )}
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>
      </main>

      <Footer />

      <Lightbox image={lightboxImage} onClose={() => setLightboxImage(null)} />
    </div>
  );
}

export default App;
